// extracted by mini-css-extract-plugin
export default {"icon":"Social_icon__rrqUN","sidebarButton":"Social_sidebarButton__mfuvn","sidebarButton1":"Social_sidebarButton1__dRV8x","social":"Social_social__Pabxb"};